// src/hr/kit/Card.js -- glass surface; `feat` adds the gradient border used on hero cards.
import React from 'react';
import { cx } from './util';

// delay: stagger index (0, 1, 2 ...) for the rise-in animation.
export function Card({ feat = false, title, action, delay, as: Tag = 'div', className, style, children, ...rest }) {
  const cardStyle = delay == null ? style : { ...style, '--hrp-delay': `${40 + Number(delay) * 50}ms` };
  return (
    <Tag className={cx('hrp-card', feat && 'hrp-card--feat', className)} style={cardStyle} {...rest}>
      {(title || action) && (
        <div className="hrp-card__head">
          {title && <h2 className="hrp-card__title">{title}</h2>}
          {action && <div className="hrp-card__action">{action}</div>}
        </div>
      )}
      {children}
    </Tag>
  );
}

export default Card;
